// extracted by mini-css-extract-plugin
export default {"card":"MediaCard_card__bY8AZ","title_container":"MediaCard_title_container__yKpmW","image":"MediaCard_image__D8dyj"};